import React, { useEffect, useState } from 'react';
import { createCncMasterMaterial, deleteCncMasterMaterial, getAllCNCMaterialMaster } from '../../../api/customer/masters/adminMastersApi';
import AdminDashboardComponents from '../../../components/HigherOrderComponents/AdminDashboardComponents';
import { toast } from 'react-toastify';

const CNCMaterialMaster = () => {
    const [allCncmaster, setAllCNCmaster] = useState([]);
    const [reload, setReload] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [materialName, setMaterialName] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const response = await getAllCNCMaterialMaster();
                setAllCNCmaster(response?.data || []);
            } catch (error) {
                console.error("Error fetching CNC materials", error);
            }
        })();
    }, [reload]);

    const openCreateModal = () => {
        setMaterialName('');
        setEditMode(false);
        setEditId('');
        setModalOpen(true);
    };

    const openEditModal = (item) => {
        setMaterialName(item.name);
        setEditMode(true);
        setEditId(item._id);
        setModalOpen(true);
    };

    const handleSave = async () => {
        if (!materialName.trim()) return;

        if (editMode) {
            // Call update API here
            console.log("Creating new with name:", materialName);
            const response = await createCncMasterMaterial({ name: materialName, id: editId });
            if (!response.success) {
                toast.error('Cannot create master material at the moment');
            };

        } else {
            // Call create API here
            console.log("Creating new with name:", materialName);
            const response = await createCncMasterMaterial({ name: materialName });
            if (!response.success) {
                toast.error('Cannot create master material at the moment');
            };
        }

        setModalOpen(false);
        setMaterialName('');
        setEditId(null);
        setReload(!reload);
    };

    const handleDelete = async (id) => {

        try {
            const res = await deleteCncMasterMaterial(id);
            if (!res.success) {
                toast.error('Cannot delete master material at the moment');
            }

        } catch (error) {
            console.error("error", error);
        }
        setReload(!reload);
    };

    return (
        <div className='w-full relative p-4'>
            <p className='text-center font-bold text-2xl my-2'>Master Material</p>
            <button
                className='bg-primaryColor absolute top-3 right-3 px-4 py-2 text-white'
                onClick={openCreateModal}
            >
                Create New
            </button>

            {/* Table */}
            <table className='w-full mt-4 border'>
                <thead>
                    <tr className='bg-gray-200'>
                        <th className='p-2 text-left'>Name</th>
                        <th className='p-2 text-left'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {allCncmaster.map(item => (
                        <tr key={item.id} className='border-t'>
                            <td className='p-2'>{item.name}</td>
                            <td className='p-2'>
                                <button
                                    onClick={() => openEditModal(item)}
                                    className='bg-primaryColor text-white px-2 py-1 mr-2'
                                >
                                    Update
                                </button>
                                <button
                                    onClick={() => handleDelete(item._id)}
                                    className='bg-red-500 text-white px-2 py-1'
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal */}
            {modalOpen && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
                    <div className='bg-white p-6 rounded shadow-md w-full max-w-md'>
                        <h2 className='text-xl font-semibold mb-4'>
                            {editMode ? 'Update Material' : 'Create New Material'}
                        </h2>
                        <input
                            type='text'
                            value={materialName}
                            onChange={(e) => setMaterialName(e.target.value)}
                            className='w-full border px-3 py-2 mb-4'
                            placeholder='Enter material name'
                        />
                        <div className='flex justify-end gap-2'>
                            <button
                                onClick={() => setModalOpen(false)}
                                className='px-4 py-2 bg-gray-300 rounded'
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSave}
                                className='px-4 py-2 bg-primaryColor text-white rounded'
                            >
                                {editMode ? 'Update' : 'Create'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboardComponents(CNCMaterialMaster);
